import Component from '@glimmer/component';

export default class NwDeepResearchKeywordClassifyingProgressComponent extends Component {
  get barProgress() {
    return (this.args.progress / this.args.totalTasks) * 100;
  }
}
